function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Container } from './SideNavigation.style';
var items = [
    {
        name: 'user',
        label: 'Users',
        path: '/user'
    },
    {
        name: 'client-credentials',
        label: 'Client Credentials',
        path: '/client-credentials'
    },
    {
        name: 'roles-management',
        path: '/roles-management',
        label: 'Roles Management'
    }
];
var SideNavigationItem = function SideNavigationItem1(param) {
    var item = param.item, _param_paddingLeft = param.paddingLeft, paddingLeft = _param_paddingLeft === void 0 ? 10 : _param_paddingLeft, _param_paddingLeftMultiplier = param.paddingLeftMultiplier, paddingLeftMultiplier = _param_paddingLeftMultiplier === void 0 ? 0 : _param_paddingLeftMultiplier;
    var toggleCollapse = function toggleCollapse() {
        setCollapsed(function(prevValue) {
            return !prevValue;
        });
    };
    var _item_items;
    var _useState = _sliced_to_array(useState(true), 2), collapsed = _useState[0], setCollapsed = _useState[1];
    var location = useLocation();
    var isActive = function isActive(path) {
        if (!path) return false;
        return location.pathname.indexOf(path) > -1;
    };
    var navigate = useNavigate();
    var onItemClick = function onItemClick(event, item) {
        event.stopPropagation();
        if (Array.isArray(item.items)) {
            toggleCollapse();
        }
        if (!item.path) return;
        if (item.external) {
            window.open(item.path);
        } else {
            navigate(item.path, {
                replace: true
            });
        }
    };
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "side-nav__list-item ".concat(isActive(item.path) ? 'active' : ''),
                onClick: function onClick(e) {
                    return onItemClick(e, item);
                },
                children: /*#__PURE__*/ _jsx("div", {
                    className: "side-nav__list-item-text",
                    style: {
                        paddingLeft: paddingLeftMultiplier * paddingLeft
                    },
                    children: item.label
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: collapsed ? 'none' : 'block'
                },
                children: Array.isArray(item.items) ? /*#__PURE__*/ _jsx("div", {
                    className: "side-nav__list",
                    children: (_item_items = item.items) === null || _item_items === void 0 ? void 0 : _item_items.map(function(subItem, index) {
                        return /*#__PURE__*/ _jsx(SideNavigationItem, {
                            item: subItem,
                            paddingLeftMultiplier: paddingLeftMultiplier + 1,
                            paddingLeft: paddingLeft
                        }, "".concat(subItem.name, "__").concat(index));
                    })
                }) : null
            })
        ]
    }, item.name);
};
var SideNavigation = function SideNavigation() {
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "side-nav__list",
            children: items.map(function(item, index) {
                return /*#__PURE__*/ _jsx(SideNavigationItem, {
                    item: item,
                    paddingLeftMultiplier: 1
                }, "".concat(item.name, "__").concat(index));
            })
        })
    });
};
export default observer(SideNavigation);
